import { endpoints } from "@app/api/apis"
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios"

export const getDspAgreement = async ( payload :  {
    applicationId : string
}) => {

    let applicationId = payload.applicationId;
    let applicationIdStored = await AsyncStorage.getItem('application_id')
  
    if (applicationIdStored) {
      applicationId = applicationIdStored;
    }  
    const response = await axios.get(`${endpoints.mandateLink}${applicationId}`);
    return response.data;
};


export const checkDspAgreementStatus = async ( payload :  {
  applicationId : string
}) => {
  let applicationId = payload.applicationId;
    let applicationIdStored = await AsyncStorage.getItem('application_id')
  
    if (applicationIdStored) {
      applicationId = applicationIdStored;
    }  
  const response = await axios.get(`${endpoints.mandateStatus}${payload.applicationId}`);
  return response.data;
}

